module.exports = __webpack_public_path__ + "img/wcold.33e390f6.png";